<template>
  <span class="error_text"><slot /></span>
</template>

<script>
export default {
}
</script>

<style>

</style>